
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';

import axios from '../../Api/axios';
import { DELAY } from '../../config';
import { useGlobalContext } from '../../Contexts/suiviMission/GlobalContext';
import Message from './Message';
import Progress from './Progress';

const FileUpload = ({ list, setlist }) => {
    FileUpload.propTypes = {
        list: PropTypes.any,
        setlist: PropTypes.func,
    };

    console.log('FileUpload comonent s Props', list, setlist);

    const [file, setFile] = useState('');
    const [filename, setFilename] = useState('Choose File');
    // const [uploadedFile, setUploadedFile] = useState({});
    const [message, setMessage] = useState('');
    const [uploadPercentage, setUploadPercentage] = useState(0);
    const { mission } = useGlobalContext();

    const onChange = (e) => {
        setFile(e.target.files[0]);
        setFilename(e.target.files[0]?.name);
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('myFile', file);
        formData.append('id', mission._id);

        // try {
        await axios
            .post('/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onUploadProgress: progressEvent => {
                    setUploadPercentage(
                        parseInt(
                            Math.round((progressEvent.loaded * 100) / progressEvent.total)
                        )
                    );
                }
            })
            .then(
                (res) => {
                    setTimeout(() => setUploadPercentage(0), DELAY);
                    setTimeout(() => setMessage(undefined), DELAY);
                    console.log(res.data);
                    setMessage('File Uploaded');
                    setlist(l => [...l, res.data.filePath]);
                },
                (err) => {
                    setTimeout(() => setUploadPercentage(0), DELAY);
                    setTimeout(() => setMessage(undefined), DELAY);
                    if (err.response.status === 500) {
                        setMessage('There was a problem with the server');
                    } else {
                        setMessage(err.response.data.message);
                    }

                    console.log(err);
                }
            );
        setUploadPercentage(0);

        // Clear percentage
        //   setTimeout(() => setUploadPercentage(0), 10000);
        //   const { fileName, filePath } = res.data;
        //   setUploadedFile({ fileName, filePath });

    // //   setMessage('File Uploaded');
    // } catch (err) {
    //   if (err.response.status === 500) {
    //     setMessage('There was a problem with the server');
    //   } else {
    //     setMessage(err.response.data.msg);
    //   }
    //   setUploadPercentage(0)
    // }
    };

    return (
        <Fragment>
            {message ? <Message msg={message} /> : null}
            <form
                onSubmit={onSubmit}
                method="POST"
                encType="multipart/form-data"
            >

                <div className="mb-3">
                    <label
                        htmlFor="formFileSm"
                        className="form-label"
                    >
                        {filename}
                    </label>
                    <input
                        type="file"
                        name="myFile"
                        onChange={onChange}
                        className="form-control form-control-sm"
                        id="formFileSm"
                    />

                </div>

                <Progress percentage={uploadPercentage} />

                <button
                    type="submit"
                    className="btn btn-primary btn-block mt-4"
                >Upload</button>
            </form>

        </Fragment>
    );
};

export default FileUpload;

{/* {uploadedFile ? (
        <div className="row mt-5">
          <div className="col-md-6 m-auto">
            <h3 className="text-center">{uploadedFile.fileName}</h3>
            <img style={{ width: "100%" }} src={uploadedFile.filePath} alt="" />
          </div>
        </div>
      ) : null} */}